import { $authHost, $host } from "./fetch"

export const createdOrderFromForm = async (game, name, server, price, coin, mail, user_id, payment_method) => {
    
    const { data } = await $host.post( 
        'order',
        {
            game, name, server, price, coin, mail, user_id, payment_method
        } 
    ) 

    return data
}

export const getUsersOrders = async () => {
    const { data } = await $authHost.post( 
        'history/orders'
    ) 
    return data
}

export const getOrderById = async (orderId) => {
    const { data } = await $host.post( 
        'order/get_by_id',
        {
            orderId
        } 
    ) 
    return data
}

export const confyrm = async (id) => {
    const { data } = await $authHost.post( 
        'history/confyrm',
        {
            id
        } 
    ) 
    return data
}

export const confyrmOrder = async (id) => {
    const { data } = await $host.post( 
        'history/confyrm_from_email',
        {
            id
        } 
    ) 
    return data
}

